const OpposingArrowsDiagonal = () => (
  <>
    <path
      fill="currentColor"
      d="m10.498 14.186-5.076 5.069a.43.43 0 0 1-.335.13.495.495 0 0 1-.475-.497q0-.207.14-.341l5.057-5.05H4.998a.48.48 0 0 1-.356-.143.49.49 0 0 1-.144-.357q0-.212.144-.356a.49.49 0 0 1 .356-.143h5.692q.344 0 .576.232a.78.78 0 0 1 .232.575v5.693q0 .212-.144.356a.49.49 0 0 1-.357.144.48.48 0 0 1-.356-.144.49.49 0 0 1-.143-.356zm3.689-3.688h4.811q.212 0 .356.144a.49.49 0 0 1 .144.356q0 .212-.144.356a.48.48 0 0 1-.356.144h-5.692a.78.78 0 0 1-.576-.233.78.78 0 0 1-.232-.575V4.998q0-.212.144-.357a.49.49 0 0 1 .357-.143q.213 0 .356.143a.49.49 0 0 1 .143.357v4.811l5.05-5.057a.45.45 0 0 1 .34-.14q.207 0 .348.14t.14.348a.45.45 0 0 1-.14.34z"
    />
  </>
)
export default OpposingArrowsDiagonal
